const config = {
 //WS_SERVER: "ws://localhost:8088/ocr_ws",
  WS_SERVER: "wss://catalogo.artlineagioielli.it/ocr_ws",

  // WS_SERVER: "wss://localhost:8088/yolo_ws", // secure
};

// export default {
//   ...config,
// };
export default config;
